import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2 } from "lucide-react";

const STATUSES = ["new", "contacted", "closed", "cancelled"];

export default function BookingsAdmin() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/bookings");
    setItems(data || []);
  };
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/bookings/${id}`, { status }); load();
  };
  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/bookings/${id}`); load();
  };

  return (
    <div data-testid="admin-bookings-page">
      <h1 className="font-display text-[#F5F1EB] text-3xl mb-8">Bookings</h1>
      <div className="grid gap-3">
        {items.map((b) => (
          <div key={b.id} className="border border-[#2A2A2A] p-4" data-testid={`booking-row-${b.id}`}>
            <div className="flex flex-wrap items-start gap-4">
              <div className="flex-1 min-w-[200px]">
                <div className="font-display text-[#F5F1EB]">{b.vehicleName}</div>
                <div className="text-xs text-[#8A8A8A] mt-1">
                  {b.pickupDate || "—"} → {b.returnDate || "—"} · {b.pickupLocation || "—"} → {b.returnLocation || "—"}
                </div>
                <div className="text-xs text-[#8A8A8A] mt-1">€{b.totalPrice?.toFixed?.(0) || 0} · lang: {b.language}</div>
                <div className="text-[10px] text-[#8A8A8A] mt-1">{b.createdAt?.slice?.(0, 19).replace("T", " ")}</div>
              </div>
              <select value={b.status || "new"} onChange={(e) => updateStatus(b.id, e.target.value)}
                className="bg-[#0C0C0C] border border-[#2A2A2A] focus:border-[#C9A55A] text-[#F5F1EB] px-3 h-10 text-sm">
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
              <button onClick={() => remove(b.id)} className="p-2 border border-[#2A2A2A] hover:border-[#B8342A] hover:text-[#B8342A]"><Trash2 size={14}/></button>
            </div>
          </div>
        ))}
        {!items.length && <div className="text-[#8A8A8A] text-sm">No bookings yet.</div>}
      </div>
    </div>
  );
}
